import React, { useContext, useMemo, useState } from 'react';
import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';

import Search from '../../components/Map/Search';
import { ProfileContext } from '../../services/profile/profile.context';
import { AddMarker } from './add-marker';
import { UserMarker } from './user-markers';

export const UserLocationMap = () => {
  const position = [29.62316571303948, 52.523923516273506];
  const { userLocation } = useContext(ProfileContext);

  const [map, setmap] = useState(null);

  useMemo(() => {
    if (map && userLocation) {
      map.setView(userLocation);
    }
  }, [userLocation, map]);

  return (
    <MapContainer
      center={position}
      zoom={15}
      whenCreated={setmap}
      zoomControl={false}
    >
      <TileLayer
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      <ZoomControl position='topright' />

      {userLocation && <UserMarker center={userLocation} />}
      {!userLocation && <AddMarker />}
      <Search />
    </MapContainer>
  );
};
